let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bJbeT")).then(() => parcelRequire('4sxUW'));